// extracted by mini-css-extract-plugin
export default {"container":"download-wizid_container__3398T","downloadtext":"download-wizid_downloadtext__1OtHv"};